module.exports = __webpack_public_path__ + "static/media/photo_requirements.7fa7c165.png";